import { render } from "./articleManagement.vue?vue&type=template&id=43d3f846"
import script from "./articleManagement.vue?vue&type=script&lang=js"
export * from "./articleManagement.vue?vue&type=script&lang=js"

import "./articleManagement.vue?vue&type=style&index=0&id=43d3f846&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__